<script setup>
import {onMounted, ref, reactive, nextTick} from "vue";
import router from "@/router/index.js";
import YTTablePagination from "@/components/YTTablePagination/YTTablePagination.vue";
import {listOrdinaryAdmin, removeOrdinary} from "@/api/user/user.js";
import YTFormDialog from "@/components/YTFormDialog/index.vue";

/*初次加载*/
onMounted(() => {
  handleSearch()
})

/*搜索功能*/
// 表单数据
const formData = reactive({
  nickname: null,
  username: null
});
// 根据表单搜索信息
const handleSearch = async (mode = 'init') => {
  if (mode === 'btnSearch') YTTablePaginationRef.value.resetPage()
  try {
    const param = ref({
      page: YTTablePaginationRef.value.getPage(),
      pageSize: YTTablePaginationRef.value.getPageSize()
    })
    loading.value = true;
    const res = await listOrdinaryAdmin(param.value, formData);
    tableData.value = []
    tableData.value = res.list
    total.value = parseInt(res.total)
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 清空表单内容
const handleReset = () => {
  formData.nickname = null
  formData.username = null
  handleSearch('btnSearch')
}

/*表格数据展示*/
// 翻页组件锚点
const YTTablePaginationRef = ref()
// 翻页信息：总条目数、加载状态
const total = ref(0)
const loading = ref(false)
const headers = ref([
  { title: '用户名', key: 'nickname', minWidth: "120px", nowrap: true },
  { title: '账号', key: 'username', nowrap: true },
  { title: '创建时间', key: 'crTime', nowrap: true },
  { title: '角色', key: 'roleName', nowrap: true },
  { title: '绑定微信', key: 'bindWechat', nowrap: true },
  { title: '绑定微信二维码', key: 'bindWechatQrCode', minWidth: "150px", nowrap: true },
  { title: '操作', key: 'controls', minWidth: "100px", fixed: true },
])
// 表格数据
const tableData = ref([])
// 翻页
const handleChangePage = () => {
  handleSearch()
}

/*操作栏功能*/
// 删除
const dialogConfirm = async (item) => {
  try {
    loading.value = true
    await removeOrdinary(item.adminId)
    loading.value = false
    await handleSearch()
  } catch (e) {
    console.log(e)
  }
}

/*跳转增加*/
const handleAdd = () => {
  router.push("/addOrdinary")
}

/*二维码弹窗*/
// 二维码弹窗状态
const open = ref(false)
// 缓存查看的二维码地址
const showQrCodeUrl = ref(null)
// 请求基地址
const url = import.meta.env.VITE_APP_ENV === "development" ? "https://dev.yttec.net/api" : import.meta.env.VITE_API_URL
const appid = import.meta.env.VITE_APP_ENV === "development" ? "wx9117abc687d73792" : import.meta.env.VITE_WECHAT_APPID
// 处理打开二维码动作
const handleOpenQrCode = (user) => {
  open.value = true
  nextTick(() => {
    new WxLogin({
      self_redirect: true,
      id: `qrCodeDialog`,
      appid: appid,
      scope: "snsapi_login",
      redirect_uri: `${url}/admin/callback/creationAdminQrCallback/${user.adminId}`,
      fast_login: 0,
      stylelite: 1
    });
  })
}
// 关闭对话框
const closeDialog = () => {
  open.value = false
  clearDialog()
}
// 关闭二维码对话框
const closeQrCodeDialog = async () => {
  open.value = false
}
// 清除对话框表单校验
const clearDialog = () => {
  showQrCodeUrl.value = null
}
</script>

<template>
  <div class="container_box mg_b_2" style="padding-bottom: 16px">
    <div class="flex_left" style="padding-left: 16px;">
      <v-btn color="success" @click="handleAdd" :disabled="!$handleHasBtnPermission('all', 'ordinaryAdmin:add')">增加用户</v-btn>
    </div>
  </div>
  <div class="container_box">
    <v-row justify="center">
      <v-col cols="9">
        <v-data-table
            :headers="headers"
            :items="tableData"
            :loading="loading"
            :items-per-page="$globalPageSize"
            :no-data-text="'没有更多数据了~'"
            hover
        >
          <template v-slot:loading>
            <v-skeleton-loader type="table-row@1"></v-skeleton-loader>
          </template>

          <template v-slot:top>
            <v-form>
              <v-container>
                <v-row justify="center">
                  <v-col cols="4">
                    <v-text-field
                        v-model="formData.nickname"
                        placeholder="请输入用户名"
                        label="用户名"
                        variant="outlined"
                        clearable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3" offset="5">
                    <v-row justify="end">
                      <v-col class="flex_right" cols="6">
                        <v-btn color="success" size="large" @click="handleSearch('btnSearch')" :disabled="!$handleHasBtnPermission('all', 'ordinaryAdmin:view')">搜索</v-btn>
                      </v-col>
                      <v-col class="flex_right" cols="6">
                        <v-btn size="large" @click="handleReset" :disabled="!$handleHasBtnPermission('all', 'ordinaryAdmin:view')">重置</v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </template>

          <template v-slot:item.bindWechat="{ item }">
            <el-text v-show="item.bindWechat === '是'" type="success">{{item.bindWechat}}</el-text>
            <el-text v-show="item.bindWechat === '否'" type="danger">{{item.bindWechat}}</el-text>
          </template>

          <template v-slot:item.bindWechatQrCode="{ item }">
            <el-text class="cursor-pointer" type="primary" v-if="item.bindWechat === '否'" @click="handleOpenQrCode(item)">打开二维码</el-text>
          </template>

          <template v-slot:item.controls="{ item }">
            <div class="flex_left">
              <el-popconfirm @confirm="dialogConfirm(item)" :title="`确定删除用户 “${item.nickname}” 吗？`">
                <template #reference>
                  <div>
                    <el-tooltip
                        class="box-item"
                        effect="dark"
                        content="删除"
                        placement="right"
                        @click.stop>
                      <v-icon class="cursor-pointer" color="error" icon="mdi-close" v-show="$handleHasBtnPermission('all', 'ordinaryAdmin:delete')"></v-icon>
                    </el-tooltip>
                  </div>
                </template>
                <template #actions="{ confirm, cancel }">
                  <div class="flex_bt">
                    <v-btn size="small" @click="cancel">取消</v-btn>
                    <v-btn size="small" color="primary" @click="confirm">确定</v-btn>
                  </div>
                </template>
              </el-popconfirm>
            </div>
          </template>

          <template v-slot:bottom>
            <YTTablePagination ref="YTTablePaginationRef" :total="total" @page-change="handleChangePage"></YTTablePagination>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
  <YTFormDialog id="dialog" :isPersistent="false" :open="open" :title="'绑定微信二维码'" :max-width="400" style="text-align: center" @close="closeDialog">
    <template v-slot:content="{form}">
      <div class="tips_default" style="font-size: 14px">若需要下载二维码,请右键点击二维码选择“图片另存为...”</div>
      <div id="qrCodeDialog" class="mg_0_auto" style="height: 260px;overflow: hidden"></div>
    </template>
    <template v-slot:actions="{form}">
      <v-row>
        <v-col cols="12">
          <div class="flex_center">
            <v-btn class="mg_l_1" variant="elevated" @click="closeQrCodeDialog">返回</v-btn>
          </div>
        </v-col>
      </v-row>
    </template>
  </YTFormDialog>
</template>

<style scoped>

</style>